import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const optimizeResumeBaseEventSchema = z.object({
  type: z.literal("completed"),
});

export class OptimizeResumeBaseEventDto extends createZodDto(optimizeResumeBaseEventSchema) {}

export * from "./optimized-iteration";
export * from "./analysis-iteration";
export * from "./optimized";
export * from "./optimization-questions";
